export const trainerToFormTransformer = trainer => {
    if (!trainer) {
        return null;
    }
    return {
        ...trainer,
        rank: trainer.rank ? trainer.rank.id : null,
        qualification: trainer.qualification ? trainer.qualification.id : null,
    };
}
